export function stripBase64Prefix(str = '') {
  if (!str) return '';
  const i = str.indexOf('base64,');
  return i !== -1 ? str.slice(i + 7) : str;
}

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = (e) => resolve(String(e.target.result));
    r.onerror = reject;
    r.readAsDataURL(file);
  });

export async function fileToPureBase64(file) {
  const withPrefix = await toBase64(file);
  return stripBase64Prefix(withPrefix);
}
